import { useQuery } from "@tanstack/react-query";

import { getSuspendedMatches } from "@/api/matches";
import { MatchesQueryKeys } from "./matchesQueryKeys";

interface Options {
  isQueryEnabled?: boolean;
  disabledCaching?: boolean;
}

export const useSuspendedMatches = (options: Options) => {
  return useQuery({
    queryKey: [MatchesQueryKeys.Suspended],
    staleTime: options.disabledCaching ? 0 : undefined,
    enabled: options.isQueryEnabled,
    queryFn: ({ signal }) => {
      const params = {};
      return getSuspendedMatches({ signal, params });
    },
  });
};
